
export default {
  name: 'ConfigurableBackground',
  values: {
    backgroundColor: undefined,
    backgroundPosition: undefined,
    backgroundRepeat: undefined,
    backgroundSize: undefined,
    backgroundImage: undefined,
    backgroundClip: undefined,
    filter: undefined,
  },
  meta: {
    extendable: false,
  },
}
